<template>
  <tr>
    <td v-for="header in headers" :key="header.text">
      <b v-if="header.value === options?.totalCalculate?.titleField">Total</b>
      {{ fmt(rowData[header.value]) }}
    </td>
  </tr>
</template>

<script>
  export default {
    props: {
      rowData: Object,
      headers: Array,
      options: Object,
      fmt: {
        type: Function,
        default: v => v,
      },
    },
  }
</script>
